export function formatPublicBuildVersion(buildInfo, versionLabel = 'Version') {
  const packageVersion = String(buildInfo?.packageVersion || 'unknown').trim() || 'unknown';

  return `${versionLabel}: ${packageVersion}`;
}
